<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.31226 12.8887L2.31226 7.89038L19.6042 7.89038V12.8887L2.31226 12.8887Z" fill="currentColor"/>
    </svg>
</template>